module.exports = __webpack_public_path__ + "img/numbering.de4f29a6.svg";